let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("04a1m")).then(() => parcelRequire('cyy85'));